"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AdsClickIcon_1 = require("../Icons/AdsClickIcon");
function SourceDropdownContainer({ children, isCollapsed, onExpand, }) {
    return (react_1.default.createElement("div", { className: "inline-flex rounded-lg p-1 bg-blue-100 min-h-[44px]" },
        isCollapsed && (react_1.default.createElement("button", { "aria-label": "Expand browse options", onClick: onExpand, className: "flex items-center" },
            react_1.default.createElement(AdsClickIcon_1.AdsClickIcon, { "aria-hidden": true, className: "mx-2 fill-blue-300" }))),
        !isCollapsed && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "flex items-center pr-1" },
                react_1.default.createElement(AdsClickIcon_1.AdsClickIcon, { "aria-hidden": true, className: "mx-2 fill-blue-300" }),
                react_1.default.createElement("span", { className: "sr-only" }, "Browse")),
            children))));
}
exports.default = SourceDropdownContainer;
